import type { ReactNode } from 'react';
import { List, ListItem, ListItemContent, ListItemText } from '@savvy-kit/components/list';
import { ChartPie, ChevronRight, CreditCard, House, Landmark, Shapes, TrendingUp } from 'lucide-react';
import { ItemType } from 'src/constants/account-link';

import type { AddAccountItemType } from './constants';
import { ADD_ACCOUNT_OPTIONS } from './constants';

const OPTION_ICONS: Record<AddAccountItemType, ReactNode> = {
  [ItemType.BANK_ACCOUNT]: <Landmark className="size-5" aria-hidden="true" />,
  [ItemType.INVESTMENT_ACCOUNT]: <TrendingUp className="size-5" aria-hidden="true" />,
  [ItemType.REAL_ESTATE]: <House className="size-5" aria-hidden="true" />,
  [ItemType.COMPANY_EQUITY]: <ChartPie className="size-5" aria-hidden="true" />,
  [ItemType.OTHER_ASSET]: <Shapes className="size-5" aria-hidden="true" />,
  [ItemType.OTHER_LIABILITY]: <CreditCard className="size-5" aria-hidden="true" />,
};

type AccountsAddAccountPickerProps = {
  readonly onSelect: (itemType: AddAccountItemType) => void;
};

export function AccountsAddAccountPicker({ onSelect }: AccountsAddAccountPickerProps) {
  return (
    <List>
      {ADD_ACCOUNT_OPTIONS.map((option) => (
        <ListItem key={option.itemType} className="p-0">
          <button
            type="button"
            className="hover:bg-component-hover flex w-full cursor-pointer items-center gap-3 px-4 py-3 text-left"
            onClick={() => {
              onSelect(option.itemType);
            }}
          >
            <span className="text-dark shrink-0">{OPTION_ICONS[option.itemType]}</span>
            <ListItemContent>
              <ListItemText primary>{option.label}</ListItemText>
              <ListItemText secondary>{option.description}</ListItemText>
            </ListItemContent>
            <ChevronRight className="text-muted-foreground size-5 shrink-0" aria-hidden="true" />
          </button>
        </ListItem>
      ))}
    </List>
  );
}
